import {
  SNACKBAR_DEFAULT_TIMEOUT,
  SNACKBAR_STYLE
} from "@/shared/constants/StyleConstants";
import { SnackbarMessageStructure } from "@/shared/models/SnackbarMessageStructure";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { mapGetters } from "vuex";
import store from "../../../store";
import { STORE_CONSTANTS } from "../../constants/GeneralConstants";

Vue.use(Vuetify);
@Component({
  name: "Snackbar",
  computed: {
    ...mapGetters({
      snackbarMessageStructure: "getSnackbarMessage"
    })
  }
})
export default class Snackbar extends Vue {
  snackbar = false;
  message = "";
  icon = "";
  timeout = SNACKBAR_DEFAULT_TIMEOUT.TIMEOUT;
  snackbarColor = "";
  snackbarMessageStructure!: SnackbarMessageStructure;

  @Watch("snackbarMessageStructure")
  dataSnackbarMessageHandler() {
    this.message = this.snackbarMessageStructure.msg;
    this.icon = this.snackbarMessageStructure.icon;
    this.snackbarColor = this.snackbarMessageStructure.color;
    if (this.snackbarMessageStructure.timeout !== undefined) {
      this.timeout = this.snackbarMessageStructure.timeout;
    }
    this.snackbar = true;
  }

  static popSuccess(msg: string) {
    store.commit(STORE_CONSTANTS.SNACKBAR_MESSAGE, {
      msg,
      icon: SNACKBAR_STYLE.SUCCESS.ICON,
      color: SNACKBAR_STYLE.SUCCESS.COLOR
    });
  }

  static popWarning(msg: string) {
    store.commit(STORE_CONSTANTS.SNACKBAR_MESSAGE, {
      msg,
      icon: SNACKBAR_STYLE.WARNING.ICON,
      color: SNACKBAR_STYLE.WARNING.COLOR
    });
  }

  static popError(msg: string, timeout?: number) {
    store.commit(STORE_CONSTANTS.SNACKBAR_MESSAGE, {
      msg,
      icon: SNACKBAR_STYLE.ERROR.ICON,
      color: SNACKBAR_STYLE.ERROR.COLOR,
      timeout: timeout
    });
  }

  static popInfo(msg: string) {
    store.commit(STORE_CONSTANTS.SNACKBAR_MESSAGE, {
      msg,
      icon: SNACKBAR_STYLE.INFO.ICON,
      color: SNACKBAR_STYLE.INFO.COLOR
    });
  }

  close() {
    this.snackbar = false;
    this.timeout = SNACKBAR_DEFAULT_TIMEOUT.TIMEOUT;
  }
}
